<template>
  <div>
    <div
      class="d-flex flex-row text-h4 align-center grey-darken-1--text justify-center justify-md-start"
    >
      <v-icon class="mr-2">$stateWaiting</v-icon>
      {{ $t(`tally.${internalName}.infoStep.timeApproximation`) }}
    </div>
    <div class="mt-6">
      {{ $t(`tally.${internalName}.infoStep.perex`) }}
    </div>
    <div class="mt-6">
      <v-list class="pa-4 grey rounded">
        <v-list-item
          v-for="(item, index) in $t(`tally.${internalName}.infoStep.list`)"
          :key="index"
          class="pa-0 align-flexstart"
          :class="{ 'mt-4': index > 0 }"
        >
          <v-img
            v-if="infoListIcons[index]"
            :src="$asset(`img/icons/${infoListIcons[index]}.svg`)"
            contain
            width="48"
            max-width="48"
            height="48"
          />
          <div class="ml-4 text-left black--text">{{ item }}</div>
        </v-list-item>
      </v-list>
    </div>
    <div class="mt-8 d-flex flex-column align-start">
      <div class="text-h3">
        {{ $t(`tally.${internalName}.infoStep.garant.title`) }}
      </div>
      <div class="d-flex flex-row mt-4">
        <v-img
          :src="$asset(`img/garant/${internalName}.png`)"
          contain
          max-width="48"
          height="48"
          class="rounded-circle"
        />
        <div class="d-flex flex-column ml-4 align-start text-left">
          <div class="text-h4">{{ $t(`tally.${internalName}.infoStep.garant.name`) }}</div>
          <div class="text-body-small grey-darken-1--text font-weight-bold mt-2">
            {{ $t(`tally.${internalName}.infoStep.garant.specialization`) }}
          </div>
          <div class="text-body-small grey-darken-1--text">
            {{ $t(`tally.${internalName}.infoStep.garant.workplace`) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TallyInfoStep',
  props: {
    internalName: {
      type: String,
      required: true
    },
    testIcon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      infoListIcons: ['register', 'report']
    };
  },
  mounted() {
    this.setDialogTitle(this.$t(`tally.${this.internalName}.infoStep.title`));
    this.setDialogLeftHeaderIcon(`icons/${this.testIcon}.svg`);
    this.setDialogButtons([
      {
        events: {
          click: () => {
            this.$emit('next-click');
          }
        },
        text: this.$t(`tally.${this.internalName}.infoStep.button`)
      }
    ]);
  },
  methods: {
    setDialogTitle(payload) {
      this.$store.dispatch(
        `staticForms/tally/${this.internalName}/infoStep/setDialogTitle`,
        payload
      );
    },
    setDialogButtons(payload) {
      this.$store.dispatch(
        `staticForms/tally/${this.internalName}/infoStep/setDialogButtons`,
        payload
      );
    },
    setDialogLeftHeaderIcon(payload) {
      this.$store.dispatch(
        `staticForms/tally/${this.internalName}/infoStep/setDialogLeftHeaderIcon`,
        payload
      );
    }
  }
};
</script>
